export const shouldForwardProp = (prop: string, defaultValidatorFn: Function) =>
  !['color', 'width', 'height', 'bgColor'].includes(prop) && defaultValidatorFn(prop);
